export abstract class BaseEntity {
  public abstract update(deltaTime: number): void;
  public abstract dispose(): void;
}
